module.exports = __webpack_public_path__ + "img/icon-medal-02.9850f669.png";